<nav class="side-menu-items-wrapper">
  <div class="side-menu-items-container">
    <ul class="side-menu-items">
      @for(item of supportsSideMenuItems; track $index){
      <li
        class="item"
        [routerLinkActive]="['active']"
        routerLinkActive
        #rla="routerLinkActive"
        [routerLink]="item.route"
        (mouseenter)="itemBeingHovered(item.route)"
        (mouseleave)="itemBeingHovered(null)"
      >
        <figure class="item-figure">
          <img
            class="item-image"
            [src]="sideMenuItemIcon(rla.isActive, item)"
            alt="Icon"
          />
        </figure>

        <p class="item-title">{{ item.translationPath | translate }}</p>
      </li>
      }
    </ul>
  </div>
</nav>
